import React from 'react';
import PrintLayout from './PrintLayout';

const S = {
  body: { position: 'absolute', top: 0, bottom: 68, left: 0, right: 0, display: 'flex' },
  left: {
    width: '55%', background: '#1e2e45',
    padding: '7% 7% 7% 6%', display: 'flex', flexDirection: 'column', justifyContent: 'center',
  },
  eyebrow: {
    fontSize: 8, fontWeight: 700, letterSpacing: '2.5px', color: '#5f7942',
    textTransform: 'uppercase', marginBottom: 14, fontFamily: 'Montserrat, sans-serif',
  },
  title: {
    fontFamily: "'Playfair Display', Georgia, serif",
    fontSize: 36, fontWeight: 700, color: '#fff', lineHeight: 1.1, marginBottom: 10,
  },
  sub: { fontSize: 10, color: 'rgba(255,255,255,0.45)', lineHeight: 1.7, marginBottom: 28 },
  divider: { width: 36, height: 2, background: '#5f7942', marginBottom: 22, borderRadius: 1 },
  metaRow: { display: 'flex', gap: 8, alignItems: 'baseline', marginBottom: 9 },
  metaLabel: {
    fontSize: 7.5, fontWeight: 700, letterSpacing: '1.5px', color: 'rgba(255,255,255,0.3)',
    textTransform: 'uppercase', width: 70, flexShrink: 0, fontFamily: 'Montserrat, sans-serif',
  },
  metaValue: { fontSize: 11.5, fontWeight: 700, color: 'rgba(255,255,255,0.88)' },
  right: {
    width: '45%', background: '#f5f4f0',
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    justifyContent: 'center', padding: '5%', gap: 10,
  },
  scoreLabel: {
    fontSize: 8, fontWeight: 700, letterSpacing: '1.2px', color: '#6b757e',
    textTransform: 'uppercase', marginBottom: 2, fontFamily: 'Montserrat, sans-serif',
  },
  ring: {
    width: 72, height: 72, borderRadius: '50%', border: '4px solid #5f7942',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    flexDirection: 'column', marginBottom: 4,
  },
  ringNum: { fontSize: 17, fontWeight: 800, color: '#1e2e45', lineHeight: 1 },
  ringLabel: { fontSize: 7, fontWeight: 600, color: '#6b757e', letterSpacing: 0.5, marginTop: 1 },
  cat: {
    width: '100%', background: 'white', border: '1px solid rgba(42,61,91,0.12)',
    borderRadius: 8, padding: '8px 12px', display: 'flex', alignItems: 'center',
    justifyContent: 'space-between',
  },
  catName: { fontSize: 9, fontWeight: 600, color: '#2a3d5b' },
  catScore: { fontSize: 11, fontWeight: 800, color: '#1e2e45' },
  barWrap: { flex: 1, height: 4, background: '#ececed', borderRadius: 2, margin: '0 8px' },
  bar: { height: '100%', borderRadius: 2, background: '#5f7942' },
};

const CATEGORIES = [
  { key: 'cc', label: 'Compelling Content' },
  { key: 'hb', label: 'Healthy Behaviors' },
  { key: 'rg', label: 'Right Chemistry' },
  { key: 'sp', label: 'Simple Process' },
];

export default function PrintCover({ meeting, inventoryScores }) {
  // inventoryScores: { sp: 0-100, cc: 0-100, hb: 0-100, rg: 0-100, overall: 0-100 }
  const rawDate = meeting.date || meeting.meetingDate || meeting.createdAt || null;
  const date = rawDate?.toDate
    ? rawDate.toDate().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
    : (typeof rawDate === 'string' ? rawDate : '');

  return (
    <PrintLayout pageNumber={1}>
      <div style={S.body}>
        <div style={S.left}>
          <div style={S.eyebrow}>Meeting Assessment Report</div>
          <div style={S.title}>{meeting.teamName || 'Team Assessment'}</div>
          <div style={S.sub}>Based on the Death by Meeting framework by Patrick Lencioni</div>
          <div style={S.divider} />
          <div>
            {(meeting.name || meeting.title) && (
              <div style={S.metaRow}>
                <div style={S.metaLabel}>Meeting</div>
                <div style={S.metaValue}>{meeting.name || meeting.title}</div>
              </div>
            )}
            <div style={S.metaRow}>
              <div style={S.metaLabel}>Date</div>
              <div style={S.metaValue}>{date}</div>
            </div>
            <div style={S.metaRow}>
              <div style={S.metaLabel}>Consultant</div>
              <div style={S.metaValue}>{meeting.consultantName || '—'}</div>
            </div>
            <div style={S.metaRow}>
              <div style={S.metaLabel}>Attendees</div>
              <div style={S.metaValue}>{(meeting.attendees || []).length} members</div>
            </div>
          </div>
        </div>
        <div style={S.right}>
          <div style={S.scoreLabel}>Overall Score</div>
          <div style={S.ring}>
            <div style={S.ringNum}>{Math.round(inventoryScores.overall ?? 0)}%</div>
            <div style={S.ringLabel}>avg</div>
          </div>
          {CATEGORIES.map(({ key, label }) => (
            <div key={key} style={S.cat}>
              <div style={S.catName}>{label}</div>
              <div style={S.barWrap}>
                <div style={{ ...S.bar, width: `${inventoryScores[key] ?? 0}%` }} />
              </div>
              <div style={S.catScore}>{Math.round(inventoryScores[key] ?? 0)}%</div>
            </div>
          ))}
        </div>
      </div>
    </PrintLayout>
  );
}
